/* ═══════════════════════════════════════════════════
   LIFESTYLE STORE THEME — Core interactions
═══════════════════════════════════════════════════ */
document.addEventListener('DOMContentLoaded', function () {

  /* ── Scroll reveal ───────────────────────────── */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in-view'); });
  }

  /* ── Mobile menu drawer ─────────────────────────── */
  var menuOpenBtns = document.querySelectorAll('.js-menu-open');
  var menuCloseBtn = document.querySelector('.js-menu-close');
  var menuOverlay = document.querySelector('.js-menu-overlay');
  var menuDrawer = document.querySelector('.js-menu-drawer');

  function openMenu() {
    if (menuOverlay) menuOverlay.classList.add('is-open');
    if (menuDrawer) menuDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (menuOverlay) menuOverlay.classList.remove('is-open');
    if (menuDrawer) menuDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  menuOpenBtns.forEach(function (btn) { btn.addEventListener('click', openMenu); });
  if (menuCloseBtn) menuCloseBtn.addEventListener('click', closeMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

  /* Drawer accordion submenus */
  document.querySelectorAll('.js-drawer-parent').forEach(function (parent) {
    parent.addEventListener('click', function () {
      var submenu = parent.nextElementSibling;
      var isOpen = parent.classList.contains('is-open');
      // close other open submenus
      document.querySelectorAll('.js-drawer-parent.is-open').forEach(function (p) {
        if (p !== parent) {
          p.classList.remove('is-open');
          if (p.nextElementSibling) p.nextElementSibling.classList.remove('is-open');
        }
      });
      parent.classList.toggle('is-open', !isOpen);
      if (submenu) submenu.classList.toggle('is-open', !isOpen);
    });
  });

  /* ── Search overlay ─────────────────────────────── */
  var searchOpenBtns = document.querySelectorAll('.js-search-open');
  var searchCloseBtn = document.querySelector('.js-search-close');
  var searchOverlay = document.querySelector('.js-search-overlay');
  var searchInput = document.querySelector('.js-search-input');
  var searchResults = document.querySelector('.js-search-results');

  function openSearch() {
    if (searchOverlay) searchOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 100);
  }
  function closeSearch() {
    if (searchOverlay) searchOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  searchOpenBtns.forEach(function (btn) { btn.addEventListener('click', openSearch); });
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) closeSearch();
    });
  }

  /* Predictive search (Shopify predictive search API) */
  var searchDebounce;
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchDebounce);
      var query = searchInput.value.trim();
      if (query.length < 2) {
        if (searchResults) searchResults.innerHTML = '';
        return;
      }
      searchDebounce = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (!searchResults) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length === 0) {
              searchResults.innerHTML = '';
              return;
            }
            searchResults.innerHTML = products.map(function (p) {
              var img = p.image ? '<img src="' + p.image + '" alt="">' : '<div style="width:44px;height:44px;background:#f4f4f4;border-radius:6px;"></div>';
              return '<a href="' + p.url + '">' + img +
                '<div><div class="pr-name">' + p.title + '</div><div class="pr-price">' + p.price + '</div></div></a>';
            }).join('');
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ── Cart drawer ─────────────────────────────────── */
  var cartOpenBtns = document.querySelectorAll('.js-cart-open');
  var cartCloseBtn = document.querySelector('.js-cart-close');
  var cartOverlay = document.querySelector('.js-cart-overlay');
  var cartDrawer = document.querySelector('.js-cart-drawer');
  var cartItemsEl = document.querySelector('.js-cart-items');
  var cartSubtotalEl = document.querySelector('.js-cart-subtotal');
  var cartCountEls = document.querySelectorAll('.js-cart-count');

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    if (!cartItemsEl) return;
    if (!cart.items || cart.items.length === 0) {
      cartItemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
    } else {
      cartItemsEl.innerHTML = cart.items.map(function (item) {
        var img = item.image ? '<img src="' + item.image + '" alt="">' : '<div style="width:72px;height:72px;background:#f4f4f4;border-radius:8px;flex-shrink:0;"></div>';
        var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="cart-line-variant">' + item.variant_title + '</p>' : '';
        return '<div class="cart-line">' + img +
          '<div class="cart-line-info"><p class="cart-line-title">' + item.product_title + '</p>' +
          variant +
          '<p class="cart-line-price">' + moneyFormat(item.final_line_price) + ' · Qty ' + item.quantity + '</p>' +
          '<a href="/cart/change?line=' + item.key + '&quantity=0" class="cart-line-remove js-cart-remove" data-key="' + item.key + '">Remove</a>' +
          '</div></div>';
      }).join('');
    }
    if (cartSubtotalEl) cartSubtotalEl.textContent = moneyFormat(cart.total_price);
    cartCountEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-zero', cart.item_count === 0);
    });
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function openCart() {
    if (cartOverlay) cartOverlay.classList.add('is-open');
    if (cartDrawer) cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCart() {
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  cartOpenBtns.forEach(function (btn) { btn.addEventListener('click', openCart); });
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* Remove line item via event delegation */
  if (cartItemsEl) {
    cartItemsEl.addEventListener('click', function (e) {
      var target = e.target;
      if (target.classList.contains('js-cart-remove')) {
        e.preventDefault();
        var key = target.getAttribute('data-key');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (res) { return res.json(); })
          .then(renderCart)
          .catch(function () {});
      }
    });
  }

  /* ── Add to cart ─────────────────────────────────── */
  document.querySelectorAll('.js-add-to-cart').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var originalContent = btn.textContent;
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = '✓';
          btn.classList.add('added');
          fetchCart();
          setTimeout(function () {
            btn.textContent = originalContent;
            btn.classList.remove('added');
            btn.disabled = false;
          }, 1400);
        })
        .catch(function () {
          btn.textContent = '!';
          setTimeout(function () {
            btn.textContent = originalContent;
            btn.disabled = false;
          }, 1400);
        });
    });
  });

  /* ── Wishlist toggle (localStorage-free, session only) ─ */
  var wishlist = [];
  document.querySelectorAll('.js-wishlist-toggle').forEach(function (btn) {
    var id = btn.getAttribute('data-product-id');
    btn.addEventListener('click', function () {
      var idx = wishlist.indexOf(id);
      if (idx > -1) {
        wishlist.splice(idx, 1);
        btn.classList.remove('is-active');
      } else {
        wishlist.push(id);
        btn.classList.add('is-active');
      }
    });
  });

  /* ── Category pills (visual active state) ─────────── */
  document.querySelectorAll('.cat-pill').forEach(function (pill) {
    pill.addEventListener('click', function (e) {
      // Only toggle visual state if it's a "#" or empty link (no navigation)
      var href = pill.getAttribute('href');
      if (!href || href === '#' || href === '') {
        e.preventDefault();
        document.querySelectorAll('.cat-pill').forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
      }
    });
  });

  /* ── Hero slider (auto-rotate if multiple slides) ──── */
  var heroSlides = document.querySelectorAll('.hero-slide');
  var heroDots = document.querySelectorAll('.hero-dot');
  if (heroSlides.length > 1) {
    var currentSlide = 0;
    function showSlide(index) {
      heroSlides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      heroDots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      currentSlide = index;
    }
    heroDots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { showSlide(i); });
    });
    setInterval(function () {
      showSlide((currentSlide + 1) % heroSlides.length);
    }, 6000);
  }

  /* ── Floating contact FAB ───────────────────────────── */
  var fabWrap = document.querySelector('.js-contact-fab-wrap');
  var fabToggle = document.querySelector('.js-contact-fab-toggle');
  if (fabWrap && fabToggle) {
    fabToggle.addEventListener('click', function () {
      var isOpen = fabWrap.classList.toggle('is-open');
      fabToggle.classList.toggle('is-open', isOpen);
    });
    document.addEventListener('click', function (e) {
      if (fabWrap.classList.contains('is-open') && !fabWrap.contains(e.target)) {
        fabWrap.classList.remove('is-open');
        fabToggle.classList.remove('is-open');
      }
    });
  }

  /* ── Product page: gallery thumbs, options, accordion ── */
  document.querySelectorAll('.product-gallery-thumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('.product-gallery-main img');
      if (mainImg) mainImg.src = thumb.getAttribute('data-full') || thumb.src;
      document.querySelectorAll('.product-gallery-thumbs img').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  document.querySelectorAll('.acc-head').forEach(function (head) {
    head.addEventListener('click', function () {
      head.parentElement.classList.toggle('is-open');
    });
  });

  document.querySelectorAll('.option-swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      if (swatch.classList.contains('is-disabled')) return;
      var group = swatch.closest('.product-option-values');
      if (group) group.querySelectorAll('.option-swatch').forEach(function (s) { s.classList.remove('is-active'); });
      swatch.classList.add('is-active');
    });
  });

  /* Quantity selector */
  document.querySelectorAll('.qty-selector').forEach(function (selector) {
    var input = selector.querySelector('input');
    var minus = selector.querySelector('.js-qty-minus');
    var plus = selector.querySelector('.js-qty-plus');
    if (minus) minus.addEventListener('click', function () {
      var val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    });
    if (plus) plus.addEventListener('click', function () {
      var val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    });
  });

  /* ── Product form add-to-cart (main product page) ─── */
  document.querySelectorAll('form[action^="/cart/add"], form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.js-add-to-cart-form, button[type="submit"]');
      if (!btn || btn.disabled) return;
      var originalContent = btn.textContent;
      btn.disabled = true;

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          fetchCart();
          if (cartOverlay) cartOverlay.classList.add('is-open');
          if (cartDrawer) cartDrawer.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          setTimeout(function () {
            btn.textContent = originalContent;
            btn.disabled = false;
          }, 1600);
        })
        .catch(function () {
          btn.textContent = 'Error — try again';
          setTimeout(function () {
            btn.textContent = originalContent;
            btn.disabled = false;
          }, 1600);
        });
    });
  });

  /* Initial cart fetch to populate badge count on load */
  fetchCart();
});
